import { createAction, props } from '@ngrx/store';
import { StockStatusListState } from '../reducers';

export const LoadStockStatusList = createAction(
  '[Stock status] Load Stock status List',
  props<{ stockStatusListData: StockStatusListState }>()
);
